export const CONSENT_MODAL_LINK_HREF = '#sirius-consent-checkbox-modal';
export const CONSENT_MODAL_LINK_SELECTOR = `a[href="${CONSENT_MODAL_LINK_HREF}"]`;
